Ext.define('SA.controller.PrepareImportController', {
    alias: 'controller.prepare-import-controller',

    constructor() {
        this.model = new SA.model.createimport.Model();

        this.activeStepIndex = 0;

        this.fileStepView = Ext.widget({xtype: 'import-file-step'});
        this.columnsStepView = Ext.widget({xtype: 'import-columns-step'});
        this.reviewStepView = Ext.widget({xtype: 'import-review-step'});

        this.importWindow = Ext.widget({
            xtype: 'import-window',
            stepViews: [this.fileStepView, this.columnsStepView, this.reviewStepView]
        });

        this.initEvents();
    },

    attemptCompleteColumnsStep() {
        var validator = new SA.model.createimport.ColumnStepValidator(this.model);

        this.model.setColumnDefinitions(this.columnsStepView.getValue());

        if (validator.hasErrors()) {
            new SA.view.ImportColumnsStepErrorWindow({errors: validator.getErrors()});
            return;
        }

        this.showReviewStep();
    },

    async attemptCompleteFileStep() {
        this.importWindow.setLoading('Reading file(s)…');

        var {countryCode, datasetName, tuples} = await this.fileStepView.getValue(),
            validator;

        this.model.setCountryCode(countryCode);
        this.model.setDatasetName(datasetName);
        this.model.setTuples(tuples);

        this.importWindow.setLoading(false);

        validator = new SA.model.createimport.FileStepValidator(this.model);

        if (!validator.isValid()) {
            new SA.view.ImportFileStepErrorWindow({validator});
            return;
        }

        this.showColumnsStep();
    },

    destroy() {
        var stepViews = ['fileStepView', 'columnsStepView', 'reviewStepView'];

        Ext.destroyMembers(this, ...stepViews, 'importWindow');
    },

    initEvents() {
        this.importWindow.on('click:back', this.onBackClick, this);
        this.importWindow.on('click:next', this.onNextClick, this);
        this.importWindow.on('click:beginImport', this.onBeginImportClick, this);
        this.importWindow.on('click:cancel', this.onCancelClick, this);

        this.fileStepView.on('change:fileItemCount', this.onFileStepViewFileItemCountChange, this);
    },

    onBackClick() {
        this.activeStepIndex--;

        this.showActiveStep();
    },

    onBeginImportClick() {
        var performImportController = new SA.controller.PerformImportController({data: this.model.serializeForRequest()});

        performImportController.on('destroy', this.destroy, this, {single: true});
    },

    onCancelClick() {
        var isFirstStep = this.activeStepIndex === 0;

        if (isFirstStep) {
            this.destroy();
            return;
        }

        Ext.widget('import-cancel-confirmation', {onCancelConfirmed: () => this.destroy()});
    },

    onFileStepViewFileItemCountChange() {
        this.importWindow.refreshSize();
        this.importWindow.ensureWindowBottomNotBelowViewport();
    },

    onNextClick() {
        if (this.activeStepIndex === 0) {
            this.attemptCompleteFileStep();
        }
        else {
            this.attemptCompleteColumnsStep();
        }
    },

    showActiveStep() {
        this.importWindow.showStepAtIndex(this.activeStepIndex);
    },

    showColumnsStep() {
        this.activeStepIndex = 1;

        this.columnsStepView.refresh(this.model.getHeaderNames());
        this.showActiveStep();
    },

    showReviewStep() {
        this.activeStepIndex = 2;

        this.reviewStepView.refresh(this.model.serializeForReview());
        this.showActiveStep();
    }
});